import { render } from "./PreActionDescription.vue?vue&type=template&id=e6237d46&scoped=true"
import script from "./PreActionDescription.vue?vue&type=script&lang=js"
export * from "./PreActionDescription.vue?vue&type=script&lang=js"

import "./PreActionDescription.vue?vue&type=style&index=0&id=e6237d46&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6237d46"]])

export default __exports__